import type { SessionView } from '@/api/hooks/shared/useSession'
import { decodeClaims, getAccessToken, isDemoSession, type Claims } from '@/auth/oidc'
import type { Role } from '@/data/types'
import { resolveLegacyProfile } from './accessLevel'

/** Operator depths that may run the book. Level 1 = Company Master, 6 = member. */
export const BOOK_MANAGEMENT_LEVELS = new Set(['2', '3', '4', '5'])

export interface BookManagementAccessInput {
  demo: boolean
  claims: Claims | null
  sessionRole?: Role
  sessionScopes?: string[]
}

/**
 * Route-level gate.
 *
 * The same rule that builds the rail decides whether the routes open: a
 * session with no admitted tier has no menu and no pages, so a hand-typed URL
 * gets the same answer as a missing link. UI hiding is not authorization —
 * this is defence in depth behind AuthGate, and the API refuses these levels
 * again on its own.
 */
export function canAccessBookManagement(input: BookManagementAccessInput): boolean {
  return resolveLegacyProfile(input) !== null
}

export function resolveBookManagementAccess(session?: SessionView): boolean {
  return canAccessBookManagement({
    demo: isDemoSession(),
    claims: decodeClaims(getAccessToken()),
    sessionRole: session?.account.role,
    sessionScopes: session?.session.scopes,
  })
}
